import axios from "@axios";

export default {
  loadTable(queryFilter) {
    let queryUrl = "";
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${
      queryFilter.sort
    },${queryFilter.order}`;
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`;
    }
    return axios.get(`/evento/eventos${queryUrl}`);
  },
  insertNewEvent(data) {
    return axios.post("/evento/eventos", data);
  },
  editEvent(data) {
    return axios.put(`/evento/eventos/${data.id}`, data);
  },
  deleteEvent(id) {
    return axios.delete(`/evento/eventos/${id}`);
  },
  getById(id) {
    return axios.get(`/evento/eventos/${id}`);
  },
  simularPreco(id) {
    return axios.get(`/evento/eventos/simular-preco/${id}`);
  },
};
